const Reuse9089 = `
... on Form9089DatahubReuse {
  occupationType
  supervisedRecruitment
  supervisedRecruitmentAttached
  playerContractAttached
  offSeasonAttached
  unionLetterAttached
  professionalAssociationAttached
  teamRevenueAttached
  playerStatisticsAttached

  empBusinessName
  empTradeName
  empAddr1
  empAddr2
  empCity
  empState
  empPostcode
  empNaics
  empNaicsDesc
  empCountry
  empProvince
  empPhone
  empPhoneext
  empFein
  
  empNumPayroll
  empYearCommenced
  empWorkerInterest
  empRelationshipWorker

  empPocLastName
  empPocFirstName
  empPocMiddleName
  empPocJobTitle
  empPocAddr1
  empPocAddr2
  empPocCity
  empPocState
  empPocPostalCode
  empPocCountry
  empPocProvince
  empPocPhone
  empPocPhoneExt
  empPocEmail

  attyAgRepType
  attyAgLastName
  attyAgFirstName
  attyAgMiddleName
  attyAgAddress1
  attyAgAddress2
  attyAgCity
  attyAgState
  attyAgPostalCode
  attyAgCountry
  attyAgProvince
  attyAgPhone
  attyAgPhoneExt
  attyAgEmail
  attyAgLawFirmName
  attyAgFEIN
  attyAgStateBarNumber
  attyAgGoodStandingState
  attyAgGoodStandingAttorney

  fwInfoAttyorAgent

  jobOppPWDAttached
  pwdWageRate
  pwdUnitOfPay
  jobOppWageFrom
  jobOppWageTo
  jobOppWagePer
  jobOppWageConditions

  primaryWorksiteType
  primaryWorksiteAddr1
  primaryWorksiteAddr2
  primaryWorksiteCity
  primaryWorksiteCounty {
    label
    value
  }
  primaryWorksiteState
  primaryWorksitePostalCode
  primaryWorksiteBlsAreaCode
  primaryWorksiteBlsArea

  isMultipleLocations
  isAppdendixBAttached

  geograpicalArea

  isFullTimeEmp
  isLiveInHousehold
  isPaidExperience
  isFwexecutedCont
  isEmpProvidedCont
  acceptDiplomaPwd
  isFwCurrentlyWrk
  isFwQualify
  empWillAccept
  empRelyExp
  fwGainExp
  empPayEducation
  jobEmpPremises
  jobComboOccup
  jobForeignLanguage
  jobReqExceed
  empUseCredential
  emprecpayment
  emPlayoff

  swaJobOrderStartDate
  swaJobOrderEndDate
  sundayPaperExists
  newspaperNameForAd
  newspaperAdPlacedDate
  advertisementMethod
  journalNameForAd
  journalAdPlacedDate

  jobFairIncluded
  jobFairFrom
  jobFairTo
  employerWebsiteIncluded
  employerWebsiteFrom
  employerWebsiteTo
  jobSearchWebsiteIncluded
  jobSearchWebsiteFrom
  jobSearchWebsiteTo
  onCampusRecruitingIncluded
  onCampusRecruitingFrom
  onCampusRecruitingTo
  tradeProfessionalIncluded
  tradeProfessionalFrom
  tradeProfessionalTo
  privateEmploymentIncluded
  privateEmploymentFrom
  privateEmploymentTo
  employeeReferralIncluded
  employeeReferralFrom
  employeeReferralTo
  campusPlacementIncluded
  campusPlacementFrom
  campusPlacementTo
  localEthnicNewspaperIncluded
  localEthnicNewspaperFrom
  localEthnicNewspaperTo
  radioTvAdIncluded
  radioTvAdFrom
  radioTvAdTo

  bargainingRep
  noBargainingRepPhysical
  noBargainingRepElectronic
  noBargainingRepInHouse
  noBargainingRepPrivate
  noBargainingRepNoNotice

  sectionIAgreement
  
  prepEmail
  prepFirmBusinessName
  prepfirstName
  prepLastName
  prepLawFirmFEIN
  prepMiddleName

  appAContLastName
  appAContFirstName
  appAContMiddleName
  appAContAddress1
  appAContAddress2
  appAContCity
  appAContPostalCode
  appAContCountryId
  appAContStateId
  appAContProvince
  appAContDOB
  appAContAdmClassId
  appAContAlienReg
  appAContBirthCountryId
  appAContCitizenCountryId

  fwEducationAppB {
    appAEduTypeId
    appAEduOther
    appAEduMajors
    appAEduInstName
    appAEduCountryId
    appAEduMonthYearAttained
  }

  fwTrainingAppC {
    appATrainingInstName
    appATrainingName
    appATrainingCert
    appATrainingStartDate
    appATrainingEndDate
    appATrainingYearAwd
  }
  
  fwSkillsAppD {
    appASkillsInstName
    appASkillsCountryId
    appASkillsStateId
    fwTerritory
    appASkillsSpecial
  }

  fwExpAppE {
    appAExpEmpName
    appAExpAddress1
    appAExpAddress2
    appAExpCity
    appAExpPostalCode
    appAExpCountryId
    appAExpStateTerritory
    appAExpProvince
    appAExpJobTitle
    appAExpStartDate
    appAExpEndDate
    appAExpFWPresent
    appAExpWorkHour
    appAExpJobDuties
  }

  appCSupp {
    sectionAndItemNum
    sectionName
    suppInfo
  } 

  appDRecruitmentInfo
  appDForeignWorkerDate
  appDPublication1
  appDPublicationDate1
  appDPublication2
  appDPublicationDate2
  appDPublication3
  appDPublicationDate3
  }
`;

export { Reuse9089 };
